import { Link } from 'react-router-dom';
import { MarketingLayout } from '@/components/layout/MarketingLayout';
import { Button } from '@/components/ui/button';

export function NotFound() {
  return (
    <MarketingLayout>
      <div className="container-px mx-auto max-w-xl py-32 text-center">
        <p className="font-serif text-accent text-6xl">404</p>
        <h1 className="font-serif text-display-lg mt-2">Página não encontrada</h1>
        <p className="mt-4 text-muted-foreground">
          A URL que você acessou não existe ou foi movida.
        </p>
        <Button asChild variant="accent" className="mt-8">
          <Link to="/">Voltar ao início</Link>
        </Button>
      </div>
    </MarketingLayout>
  );
}
